import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { useCallback, useContext } from 'react';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { getReportDatasetFromReportResolve } from 'reporting-data/report/reportResolveUtils';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import useCloneTracker from '../../../../hooks/useCloneTracker';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { isReportValidForReportGetterStrategy } from 'reporting-ui-components/lib/report-strategies/utils/strategyFetchers';
import AILoadingPills from '../../../shared/AILoadingPills';
import InsightComponent from '../../fullPage/report-ai-assistant-insights/InsightComponent';
import { getIsInsightsShown, getReportDatasetHasNotEnoughDataForAIInsights } from '../../fullPage/report-ai-assistant-insights/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportInsightsContent = ({
  appUsageTracker,
  report,
  reportResolve,
  insightsFetch
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  const userInfo = useContext(UserInfoContext);
  const reportDatasetIsUndefinedOrHasFewerThan1DataPoint = getReportDatasetHasNotEnoughDataForAIInsights(report, reportResolve);

  // trellis has wrong type set on this onChange
  const onExpandedChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (isReportValidForReportGetterStrategy(report)) {
      tracker.track('reportingAIAssistantInsightsInteraction', {
        action: 'expandInsights',
        isOpen: value,
        chartType: getStandardFieldType(report, STANDARD_FIELD_TYPES.CHART_TYPE)
      });
    }
  }, [tracker, report]);
  if (!getIsInsightsShown(report, userInfo)) {
    return null;
  } else if (reportDatasetIsUndefinedOrHasFewerThan1DataPoint) {
    return /*#__PURE__*/_jsx(Text, {
      "data-test-id": "report-vis-insights-empty",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.platformReport.reportVisualizationInsights.emptyDataset"
      })
    });
  } else if (isLoading(insightsFetch) || !reportResolve) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "report-vis-insights-loading",
      children: /*#__PURE__*/_jsx(AILoadingPills, {
        rows: 3
      })
    });
  } else if (isSucceeded(insightsFetch)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "report-vis-insights-success",
        children: /*#__PURE__*/_jsx(ExpandableText, {
          maxHeight: 100,
          onExpandedChange: onExpandedChange,
          children: insightsFetch.data.insights.map(insight => /*#__PURE__*/_jsx(View, {
            marginBlock: "300",
            children: /*#__PURE__*/_jsx(InsightComponent, {
              appUsageTracker: tracker,
              insight: insight,
              correlationId: insightsFetch.data.groupCorrelationId,
              report: report,
              dataset: getReportDatasetFromReportResolve(report, reportResolve)
            })
          }, insight.value))
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs("p", {
    "data-test-id": "report-vis-insights-failure",
    role: "alert",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.singleReportViewer.AIReportSummary.insights.error"
    }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.singleReportViewer.AIReportSummary.insights.errorCta"
    })]
  });
};
export default ReportInsightsContent;